import React, { Component } from 'react';
import EventBus from '../service/eventbus';
import { FaCheck } from 'react-icons/fa';
import { BiErrorCircle } from 'react-icons/bi';
import { isAuthenticated, getStudyItems, enrollItem, deleteEnrollStudyItem, getStudent, updateStudent } from '../service/service';
import { ListGroup, ListGroupItem, Button, Spinner, Modal, ModalHeader, ModalBody, ModalFooter, Collapse } from 'reactstrap';
import { Form, FormGroup, Label, Input, FormText } from 'reactstrap';


export class Enroll extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            student: null,
            studyItems: [],
            currentItem: null,
            enrolling: false,
            showEnrollStatus: false,
            enrollStatus: null,

            showDeleteModal: false,
            showDeleteStatus: false,
            deletingItem: null,
            deleteStatus: null,

            showDetailsForm: false,
            errorEmail: false,
            errorPhone: false,
            authorized: false,

        };
        this.reloadContent = this.reloadContent.bind(this);
        this.itemSelected = this.itemSelected.bind(this);
        this.enrollCurrentItem = this.enrollCurrentItem.bind(this);
        this.storeDetailsForm = this.storeDetailsForm.bind(this);
        this.email = "";
        this.phone = "";
    }

    async componentDidMount() {
        document.title = 'הרשמה לקורסים';

        EventBus.on('studyYearChanged', this.reloadContent);
        await this.reloadContent();
    }

    async componentWillUnmount() {
        EventBus.off('studyYearChanged', this.reloadContent);
    }

    async reloadContent() {
        console.log('reloading enroll content');

        var auth = await isAuthenticated();
        var items = await getStudyItems();
        var student = await getStudent();
        this.setState({ authorized: auth !== false, loading: false, studyItems: items, currentItem: null, student: student });
    }

    async itemSelected(item) {
        if (this.state.currentItem === item)
            this.setState({ currentItem: null });
        else
            this.setState({ currentItem: item });
    }

    async enrollCurrentItem() {
        if (this.state.student == null)
            return;

        this.setState({ enrolling: true });
        if (this.state.student.email == null || this.state.student.email === "" ||
            this.state.student.phone == null || this.state.student.phone === "") {
            this.setState({ showDetailsForm: true });
            return;
        }

        //console.log(this.state);
        var tmp = await enrollItem(this.state.currentItem.id);
        var items = await getStudyItems();
        this.setState({ enrolling: false, showEnrollStatus: true, enrollStatus: tmp, studyItems: items });
    }

    async storeDetailsForm(formEvent) {
        console.log(this.phone);
        console.log(this.validatePhone(this.phone));

        var error = false;
        if (this.validateEmail(this.email) == null) {
            this.setState({ errorEmail: true });
            error = true;
        }
        else {
            this.setState({ errorEmail: false });
        }

        if (this.validatePhone(this.phone) == null) {
            this.setState({ errorPhone: true });
            error = true;
        }
        else {
            this.setState({ errorPhone: false });
        }
        if (error)
            return;

        await updateStudent({ email: this.email, phone: this.phone });

        var student = await getStudent();
        this.setState({ student: student, showDetailsForm: false });

        this.enrollCurrentItem();
    }

    async hideEnrollStatus() {
        this.setState({ enrolling: false, showEnrollStatus: false, enrollStatus: null });
    }

    async deleteEnroll(item) {
        this.setState({ showDeleteModal: true, deletingItem: item });
    }

    async deleteModelAction(ac) {
        if (ac === true) {
            if (this.state.deletingItem) {
                var status = await deleteEnrollStudyItem(this.state.deletingItem.id);
                var items = await getStudyItems();
                this.setState({ showDeleteModal: false, showDeleteStatus: true, deletingItem: null, deleteStatus: status, studyItems: items, currentItem: null });
            }
            else {
                this.setState({ showDeleteModal: false, deletingItem: null });
            }
        }
        else {
            this.setState({ showDeleteModal: false, deletingItem: null });
        }
    }

    async deleteModelStatusHide() {
        this.setState({ showDeleteModal: false, showDeleteStatus: false, deletingItem: null, deleteStatus: null });
    }

    validateEmail (email) {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    validatePhone(phone) {
        return String(phone)
            .toLowerCase()
            .match(
                /^[\+]?[(]?[0-9]{2,3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
            );
    };


    render() {
        return (
            <div>
                {this.state.loading === true &&
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"/>
                }
                {this.state.authorized === false && this.state.loading === false &&
                    <div>
                        <h1>ברוכים הבאים לאתר הרשמה</h1>
                        <p>אנא בצעו כניסה למערכת</p>
                        <button className="btn btn-primary" onClick={this.ssoSignIn}>כניסה למערכת</button>
                    </div>
                }
                {this.state.studyItems.length === 0 && this.state.loading === false && this.state.authorized === true &&
                    <div className="shf-item-description">לא נמצאו קבוצות להרשמה</div>
                }
                {this.state.studyItems.length > 0 && this.state.loading === false && this.state.authorized === true &&
                    <div>
                        <div className="shf-item-description">רשימת קורסים להרשמה</div>
                        <ListGroup className="shf-list">
                            {this.state.studyItems.map(si =>
                                <ListGroupItem
                                    action
                                    key={si.id}
                                    style={{ padding: '0px' }}
                                    active={this.state.currentItem === si}>
                                    <table width="100%">
                                        <tbody>
                                        <tr onClick={() => this.itemSelected(si)}>
                                            <td style={{ padding: '10px' }}>
                                                <div style={{ float: "right" }}>
                                                    {si.status > 0 &&
                                                        <FaCheck color={this.state.currentItem === si ? "white" : "green"} style={{marginLeft:'3px'}}/>}
                                                    {si.name}
                                                </div>
                                                {si.limit > 0 && si.limit < 1000000 &&
                                                <div style={{ float: "left" }}>
                                                    {si.limit}
                                                    &nbsp;
                                                    מקומות פנויים
                                                </div>}
                                                {si.limit === 0 &&
                                                    <div style={{ float: "left" }}>
                                                        רשימת המתנה
                                                </div>}
                                            </td>
                                            </tr>
                                            {this.state.currentItem === si &&
                                            <tr>
                                                <td>
                                                    <div style={{ backgroundColor: 'white', padding: '10px', color: '#555555' }}>
                                                        <div>
                                                            {this.state.currentItem.description &&
                                                                <div>
                                                                    <div className="shf-item-description">תאור הקורס</div>
                                                                    <section dangerouslySetInnerHTML={{ __html: this.state.currentItem.description }} />
                                                                </div>
                                                            }
                                                            {this.state.currentItem.timetable &&
                                                                <div>
                                                                    <div className="">
                                                                        <br />
                                                                        <div><b>מפגשים</b></div>
                                                                        {this.state.currentItem.timetable.map(tti =>
                                                                            <div key={tti.id}>
                                                                                {tti.description}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    {this.state.currentItem.payment &&
                                                                        <div className="">
                                                                            <br />
                                                                            <div><b>תשלום</b></div>
                                                                        מחיר הרשמה לקורס זה: {this.state.currentItem.price + " ש\"ח"}<br />
                                                                            <a href={this.state.currentItem.paymentUrl} target="_blank" rel="noopener noreferrer">לתשלום</a>
                                                                        </div>}
                                                                </div>
                                                            }
                                                            <br />
                                                        </div>
                                                        <div>
                                                            {this.state.currentItem.status === 0 ?
                                                                (this.state.currentItem.block === 1 ?
                                                                    <div>
                                                                        <b>נרשמת לכמות מירבית של קורסים, אם ברצונך להירשם לקורס זה, יש לבטל הרשמה בקורס אחר</b>
                                                                    </div>
                                                                    :
                                                                    <Button
                                                                        color="primary"
                                                                        disabled={this.state.enrolling}
                                                                        onClick={this.enrollCurrentItem}>
                                                                        {this.state.enrolling &&
                                                                            <Spinner
                                                                                as="span"
                                                                                animation="border"
                                                                                size="sm"
                                                                                role="status"
                                                                            />
                                                                        }
                                                                הרשם לקורס זה
                                                                </Button>)
                                                                :
                                                                <div>
                                                                    הינך כבר רשום לקורס זה, אם ברצונך לבטל הרשמה לחץ/י
                                                                    <br /><br />
                                                                    <Button
                                                                        color="danger"
                                                                        onClick={() => this.deleteEnroll(this.state.currentItem)}>
                                                                        בטל הרשמה
                                                                    </Button>
                                                                </div>}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                        </tbody>
                                    </table>
                                </ListGroupItem>
                            )}
                        </ListGroup>
                    </div>
                }
                
                <Modal isOpen={this.state.showEnrollStatus} style={{ direction: 'rtl', textAlign: 'right' }}>
                    <ModalHeader>הרשמה לקורס</ModalHeader>
                    <ModalBody>
                        {this.state.enrollStatus && this.state.enrollStatus.status === 'FAIL' &&
                            <div>
                            <BiErrorCircle color="red" size="35px" style={{ marginLeft: '10px' }}/>
                            תהליך הרשמה נכשל,
                            &nbsp;
                            {this.state.enrollStatus.message != null ?
                                <span>{this.state.enrollStatus.message}</span>
                                :
                                <span>אנא נסו שוב</span>}
                            </div>
                        }
                        {this.state.enrollStatus && this.state.enrollStatus.status === 'SUCCESS' &&
                            <div>
                            <FaCheck color="green" size="35px" style={{marginLeft:'10px'}}/>
                            תהליך הרשמה לקורס בוצע בהצלחה
                            </div>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => this.hideEnrollStatus()}>המשך</Button>{' '}
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showDeleteModal} style={{ direction: 'rtl', textAlign: 'right' }}>
                    <ModalHeader toggle={this.toggle}>ביטול הרשמה</ModalHeader>
                    <ModalBody>
                        <div>
                            האם ברצונך לבטל הרשמה לקורס  ?
                                </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={() => this.deleteModelAction(true)}>בטל הרשמה</Button>{' '}
                        <Button color="secondary" onClick={() => this.deleteModelAction(false)}>לא לבטל הרשמה</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showDeleteStatus} style={{ direction: 'rtl', textAlign: 'right' }}>
                    <ModalHeader>ביטול הרשמה</ModalHeader>
                    <ModalBody>
                        {this.state.deleteStatus && this.state.deleteStatus.status === 'FAIL' &&
                            <div>
                                ביטול הרשמה נכשל, אנא נסו שוב
                                    </div>
                        }
                        {this.state.deleteStatus && this.state.deleteStatus.status === 'SUCCESS' &&
                            <div>
                                ביטול הרשמה בוצע בהצלחה
                                    </div>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => this.deleteModelStatusHide()}>המשך</Button>{' '}
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showDetailsForm} style={{ direction: 'rtl', textAlign: 'right' }}>
                    <ModalHeader>אנא הזינו פרטים</ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup className="mb-3">
                                <Label for="emailControl">כתובת דואר אלקטרוני</Label>
                                <Input
                                    type="email" name="email" id="emailControl"
                                    style={{ direction: 'ltr' }}
                                    onChange={(e) => this.email = e.target.value}
                                    invalid={this.state.errorEmail} />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label for="phoneControl">מספר טלפון נייד</Label>
                                <Input type="phone" name="phone" id="phoneControl"
                                    style={{direction: 'ltr'}}
                                    onChange={(e) => this.phone = e.target.value}
                                    invalid={this.state.errorPhone} />
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" type="submit"
                            onClick={() => this.storeDetailsForm(this)}>המשך</Button>{' '}
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
